import { render, staticRenderFns } from "./PickWait.vue?vue&type=template&id=c679a70e&scoped=true&"
import script from "./PickWait.vue?vue&type=script&lang=js&"
export * from "./PickWait.vue?vue&type=script&lang=js&"
import style0 from "./PickWait.vue?vue&type=style&index=0&id=c679a70e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c679a70e",
  null
  
)

export default component.exports